import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ContentView from '../components/ContentView';
import { getContentBook } from '../content';
import {
  DEFAULT_CONTENT_LINKS,
  type ContentPageKey,
  type WebsiteContentLinks,
} from '../../utils/websiteSsr/content';
import { getApiPath, PATH_PREFIX } from '../pathPrefix';
import { useWebsiteAppContext } from '../hooks/useWebsiteAppContext';

export default function ContentScreen({ pageKey }: { pageKey: ContentPageKey }) {
  const { i18n } = useTranslation();
  const { appConfig, categories, ensureCatalogLoaded } = useWebsiteAppContext();
  const language = i18n.resolvedLanguage ?? i18n.language;
  const [links, setLinks] = useState<WebsiteContentLinks>(DEFAULT_CONTENT_LINKS);
  useEffect(() => {
    const controller = new AbortController();
    void fetch(getApiPath('/web/content'), { signal: controller.signal })
      .then((response) => (response.ok ? response.json() : null))
      .then((response: { data: WebsiteContentLinks } | null) => {
        if (response) setLinks(response.data);
      })
      .catch(() => {});
    return () => controller.abort();
  }, []);
  useEffect(() => {
    if (pageKey === 'home') void ensureCatalogLoaded();
  }, [pageKey, ensureCatalogLoaded]);
  return (
    <ContentView
      pageKey={pageKey}
      book={getContentBook(language)}
      links={links}
      language={language}
      pathPrefix={PATH_PREFIX}
      settings={appConfig}
      categories={categories}
    />
  );
}
